import React, { useState, useEffect } from 'react';
import { makeStyles, Theme, createStyles, List, ListItem, ListItemText, Divider, Button, TextField, Paper, Typography } from '@material-ui/core';
import { ReactSortable } from 'react-sortablejs';
import { PersonAdd as PersonAddIcon } from '@material-ui/icons';
import validator from "validator"
import { useTranslation } from "react-i18next"

import  * as Lambda from "../../../../../Lambda";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      textAlign: "left"
    },
    userAdd: {
      margin: 8,
    },
    userPanelContainer: {
      display: "flex",
    },
    userPanel: {
      margin: 8,
      border: "solid #aaaaaa 1px",
      borderRadius: "8px",
      backgroundColor: theme.palette.background.paper,
      flexGrow: 1,
      flexDirection: "column",
      display: "flex",
    },
    sortArea: {
      flexGrow: 1,
    },
    content: {
      backgroundColor: "white",
      margin: theme.spacing(1),
      padding: theme.spacing(1),
    }
  }),
);

interface Member {
  id:string
  name: string
  email: string
  invitation: boolean
  join: boolean
}

interface Props {
  room: Lambda.RoomType | undefined
  setRoom?: (input: Lambda.RoomType|undefined) => void | undefined
}

function SettingView(props: Props) {

    const classes = useStyles()
    const [t] = useTranslation()

    console.log(props)

    const [invitationAddress, setInvitationAddress] = useState("")
    const [members, setMembers] = useState<Member[]>([])
    const [deleteMembers, setDeleteMembers] = useState<Member[]>([])

    useEffect(()=>{
      setMembers(props?.room?.members?.map((member) => ({ name: t("status.invite"), invitation: false, ...member })) || []);
      setDeleteMembers([])
    },[props, t])

    const invitation = async () => {
      setInvitationAddress("")
      if (!members.find((member)=>member.email === invitationAddress)) {
        setMembers([...members,{id:invitationAddress, name: "", email:invitationAddress, invitation:true, join:false}])
      }
    }
    const reflect = async () => {
      const response = await Lambda.putRoomMembers({roomId: props.room?.id || "", members: members.map(member=>({email: member.email}))})
      if (props.setRoom && props.room && members) {
        props.setRoom({
          ...props.room,
          members: response
        })
        setMembers(response.map((member) => ({ name: t("status.invite"), invitation: false, ...member })) || []);
        setDeleteMembers([])
      }
    }

    return (
        <div className={classes.root}>
            <Divider />
            <Paper>
              <div className={classes.content}>
                <div>
                  <Typography variant="h4" >{t("message.settingView.member")}</Typography>
                  <TextField value={invitationAddress} onChange={(e)=>setInvitationAddress(e?.target?.value)}/>
                  <Button 
                    variant="contained" 
                    className={classes.userAdd}
                    disabled={ ! (validator.isEmail(invitationAddress) && !members.find(member=>member.email === invitationAddress) ) }
                    onClick={()=>invitation()}
                  >
                    <PersonAddIcon />
                    <Typography>{t("message.settingView.inviteMember")}</Typography>
                  </Button>
                </div>
                <div className={classes.userPanelContainer}>
                  <List className={classes.userPanel}>
                    <ListItem>
                      <ListItemText>{t("message.settingView.currentMember")}</ListItemText>
                    </ListItem>
                    <Divider />

                    <ReactSortable 
                      list={members} 
                      setList={setMembers}
                      animation={200}
                      group="users"
                      className={classes.sortArea}
                    >
                      {members.map(item=>(
                        <ListItem key={item.id} style={item.invitation ? {backgroundColor: "#c8fac8"} : item.join ? {} : {backgroundColor: "#ccc"}}>
                          <ListItemText secondary={item.email}>{item.name}</ListItemText>
                        </ListItem>
                      ))}

                    </ReactSortable>
                  </List>

                  <List className={classes.userPanel}>
                    <ListItem>
                      <ListItemText>{t("message.settingView.deleteMember")}</ListItemText>
                    </ListItem>
                    <Divider />

                    <ReactSortable 
                      list={deleteMembers} 
                      setList={setDeleteMembers}
                      animation={200}
                      group="users"
                      className={classes.sortArea}
                    >
                      {deleteMembers.map(item=>(
                        <ListItem key={item.id} style={item.id === props?.room?.owner ? {backgroundColor: "#fd8"} : (item.join ? {} : {backgroundColor: "#ccc"})}>
                          <ListItemText secondary={item.email}>{item.name}</ListItemText>
                        </ListItem>
                      ))}

                    </ReactSortable>
                  </List>
                </div>
                <Button 
                  variant="contained" 
                  color="primary"
                  onClick={async ()=>reflect()}>{t("message.settingView.apply")}</Button>
              </div> 
            </Paper>
        </div>
    )
}

export default SettingView;